import Checkout from '@screens/checkout'

export default function CheckoutPage() {
  return <Checkout />
}
